export enum areaagencyrole {
  AreaTeachingCommitteeMember = 200630010,
  AreaTeachingCommitteeSecretary = 200630009,
  AuxiliaryBoardMemberforPropagation = 200630017,
  AuxiliaryBoardMemberforProtection = 100000001,
  Chairman = 200630004,
  ChildrensClassCoordinator = 200630014,
  ClusterDevelopmentFacilitator = 200630012,
  ClusterGroupSeekerResponseCoordinator = 200630026,
  ClusterInstituteCoordinator = 200630011,
  ClusterSeekerResponseCoordinator = 200630025,
  ClusterStatisticsOfficerFlowofInformationCoordinator = 200630016,
  HomefrontPioneer = 200630018,
  JuniorYouthCoordinator = 200630015,
  LocalityContactPerson = 200630023,
  LocalSpiritualAssemblySecretary = 200630001,
  Member = 200630007,
  NationalInquiryServicesTeam = 200630024,
  RecordingSecretary = 200630003,
  RegionalCouncilSecretary = 200630022,
  RegionalDevelopmentFacilitator = 200630021,
  RegionalSeekerResponseCoordinator = 200630028,
  RegionalStatisticsOfficer = 200630019,
  RegionalTrainingInstituteCoordinator = 200630020,
  RegisteredGroupContactPerson = 200630008,
  StudyCircleCoordinator = 200630013,
  SubRegionalSeekerResponseCoordinator = 200630027,
  TeachingTeams = 200630000,
  Treasurer = 200630006,
  ViceChairman = 200630005,
}
